const StickyBookingLink = () => {
	const domEl = document.querySelector('#booking-link-sticky');
	if(!domEl) {
		return;
	}

	let lastScrollTop = 0;

	const render = () => {

		const currentScroll = window.scrollY || document.documentElement.scrollTop;

		if(currentScroll > 200) {
			domEl.classList.add('js-visible');
		} else {
			domEl.classList.remove('js-visible');
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
	};

	window.addEventListener('scroll', render);
	render();
	domEl.classList.add('js-initialized');
};

export default StickyBookingLink;